import React, { useEffect } from "react";
import { Phone, Mail, MapPin, Clock, MessageSquare } from "lucide-react";
import { company } from "../mock";
import QuoteForm from "../components/QuoteForm";

const Contact = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const infoCards = [
    {
      icon: MapPin,
      title: "Visit Us",
      lines: [company.address],
    },
    {
      icon: Phone,
      title: "Call Us",
      lines: [company.phone],
      href: `tel:${company.phoneRaw}`,
    },
    {
      icon: Mail,
      title: "Email Us",
      lines: [company.email],
      href: `mailto:${company.email}`,
    },
  ];

  return (
    <div className="relative">
      <section className="relative overflow-hidden">
        <div className="aurora bg-[#8ec4ec] h-80 w-80 -top-24 -left-16" />
        <div className="aurora bg-[#8ec4ec] h-80 w-80 top-0 right-0" />
        <div className="max-w-7xl mx-auto px-6 pt-16 pb-10 text-center relative z-10 fade-up">
          <span className="inline-flex items-center gap-2 glass px-4 py-1.5 rounded-full text-sm font-semibold text-[#003c7a] mb-5">
            <MessageSquare size={15} /> We're here to help
          </span>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-[#0a2b52]">
            Get in touch with <span className="brand-gradient-text">Cloverdale</span>
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl mx-auto">
            Have a question or ready for a free quote? Our friendly Surrey-based
            team is open 7 days a week.
          </p>
        </div>
      </section>

      {/* Info cards */}
      <section className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-6">
          {infoCards.map((c) => {
            const Icon = c.icon;
            const content = (
              <div className="glass rounded-3xl p-7 card-hover h-full">
                <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-[#0066b3] to-[#003c7a] flex items-center justify-center text-white mb-4">
                  <Icon size={24} />
                </div>
                <h3 className="font-display font-bold text-lg text-[#0a2b52]">
                  {c.title}
                </h3>
                {c.lines.map((l) => (
                  <p key={l} className="text-slate-600 mt-1.5">
                    {l}
                  </p>
                ))}
              </div>
            );
            return c.href ? (
              <a key={c.title} href={c.href}>
                {content}
              </a>
            ) : (
              <div key={c.title}>{content}</div>
            );
          })}
        </div>
      </section>

      {/* Form + hours/map */}
      <section className="max-w-7xl mx-auto px-6 pt-16">
        <div className="grid lg:grid-cols-2 gap-10">
          <div className="glass-strong rounded-3xl p-7 md:p-9">
            <h2 className="font-display text-2xl font-bold text-[#0a2b52] mb-6">
              Send us a message / request a quote
            </h2>
            <QuoteForm />
          </div>

          <div className="space-y-6">
            <div className="glass-strong rounded-3xl p-7">
              <h3 className="font-display font-bold text-xl text-[#0a2b52] flex items-center gap-2 mb-5">
                <Clock size={20} className="text-[#0066b3]" /> Working Hours
              </h3>
              <div className="space-y-3">
                {company.hours.map((h) => (
                  <div
                    key={h.day}
                    className="flex items-center justify-between border-b border-slate-200/60 pb-3 last:border-0"
                  >
                    <span className="text-[#0a2b52] font-medium">{h.day}</span>
                    <span className="text-[#0066b3] font-semibold">{h.time}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="glass-strong rounded-3xl p-2 overflow-hidden">
              <iframe
                title="Cloverdale Insurance location"
                src={company.mapEmbed}
                className="w-full h-[280px] rounded-2xl border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
